export default __webpack_public_path__ + "static/game_logo_small-01be1443c8c718994fb4fc88baba716a.svg";